<template>
  <client-spend
    :entries="entries"
    :loading="loading"
  />
</template>
<script>
import ClientSpend from './ClientSpend';

export default {
  name: 'ClientSpendContainer',
  components: {
    ClientSpend,
  },

  data() {
    return {

    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.item;
    },
    loading() {
      return this.$store.state.customers.itemLoading;
    },
    entries() {
      if (!this.customer) return [];

      return [{
        name: 'Lifetime Spend',
        value: this.$options.filters.formatPrice(this.customer.total_sales, 0),
      }, {
        name: '12 month spend',
        value: this.$options.filters.formatPrice(this.customer.mo12_sales, 0),
      }, {
        name: 'returns',
        value: this.$options.filters.formatPrice(this.customer.total_returns, 0),
      }, {
        name: 'Return Rate',
        value: `${this.$options.filters.formatFloat(this.customer.total_sales === 0 ? 0 : ((100.0 * this.customer.total_returns) / this.customer.total_sales))}%`,
      }];
    },
  },
};
</script>
